const swiperConfig = {
  speed: 400,
  centeredSlides: true,
  spaceBetween: 10,
};

const cartCompareLabel = [
  "防水性",
  "透湿性",
  ["携行性", "（軽さ）"],
  ["耐久性", "（生地強度）"],
  ["耐風安定性", "（ばたつき", "制御）"],
];

const chartCompareData = {
  alpha_sv: {
    title: "ALPHA SV JACKET",
    data: [100, 60, 60, 100, 100],
  },
  alpha: {
    title: "ALPHA JACKET",
    data: [100, 100, 80, 80, 80],
  },
  alpha_sl: {
    title: "ALPHA SL JACKET",
    data: [100, 100, 100, 60, 40],
  },

  beta_sv: {
    title: "BETA SV JACKET",
    data: [100, 60, 60, 100, 100],
  },
  beta_ar: {
    title: "BETA AR JACKET",
    data: [100, 80, 60, 80, 80],
  },
  beta: {
    title: "BETA JACKET",
    data: [100, 80, 80, 80, 80],
  },
  beta_sl: {
    title: "BETA SL JACKET",
    data: [100, 80, 80, 60, 60],
  },
};

const lenis = new Lenis({
  duration: 1.2,
  smoothWheel: true,
});

const raf = (time) => {
  lenis.raf(time);
  requestAnimationFrame(raf);
};

/**
 * 下層ページのスライダー
 * https://swiperjs.com/get-started
 */
const setSwiper = (wrap) => {
  const sections = wrap.querySelectorAll("#fysj .product");

  sections.forEach((section) => {
    const imageSwiper = new Swiper(section.querySelector(".slider__image"), {
      ...swiperConfig,
      slidesPerView: 1.4,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
      },
    });

    const textSwiper = new Swiper(section.querySelector(".slider__text"), {
      ...swiperConfig,
      slidesPerView: 1,
    });

    imageSwiper.controller.control = [textSwiper];
    textSwiper.controller.control = [imageSwiper];
  });
};

/**
 * モーダルのレーダーチャート
 * https://www.chartjs.org/docs/latest/
 * @param {*} wrap
 * @param {*} targetId
 * @returns
 */
const setRaderChart = (wrap, targetId, animation = true) => {
  const canvas = wrap.querySelector(".chart");
  const ctx = canvas.getContext("2d");
  const itemName = wrap.querySelector(".name");
  if (itemName) itemName.dataset.title = chartCompareData[targetId].title;

  return new Chart(ctx, {
    type: "radar",
    data: {
      labels: animation ? cartCompareLabel : ["", "", "", "", ""],
      datasets: [
        {
          data: chartCompareData[targetId].data,
          backgroundColor: "rgba(215, 209, 125, 0.6)",
          borderColor: "rgba(126, 121, 50, 1)",
          borderWidth: animation ? 4 : 0,
          animation: animation,
          fill: true,
          pointBackgroundColor: "rgba(126, 121, 50, 1)",
        },
      ],
    },
    options: {
      plugins: {
        legend: {
          display: false,
        },
      },
      scales: {
        r: {
          min: 0,
          max: 100,
          ticks: {
            display: false,
            stepSize: 20,
          },
        },
      },
      elements: {
        point: {
          radius: animation ? 3 : 2,
          borderWidth: 1,
        },
      },
    },
  });
};

/**
 * モーダルのセット
 * https://micromodal.vercel.app/
 */
const setModal = (wrap) => {
  const trigger = wrap.querySelectorAll("[data-micromodal-trigger]");
  let targetId = "";
  let chart = null;
  console.log(trigger);

  trigger.forEach((t) => {
    t.addEventListener("click", (e) => {
      targetId = e.currentTarget.dataset.id;
      wrap.setAttribute("data-modal-id", targetId);
      console.log(targetId);
    });
  });

  MicroModal.init({
    disableScroll: true,
    // awaitOpenAnimation: true,
    // awaitCloseAnimation: true,
    onShow: (modal) => {
      chart = setRaderChart(modal, targetId);
    },
    onClose: (modal) => {
      console.info(`${modal.id} is hidden`);
      wrap.setAttribute("data-modal-id", "");
      chart.destroy();
    },
  });
};

/**
 * スクロール滑らか＆パララックス処理
 * @param {*} wrap
 */
const setParallax = (wrap) => {
  const items = [...wrap.querySelectorAll('[data-anime="parallax"]')];

  const current = items
    .map((el) => ({
      el,
      img: el.querySelector("img"),
      progress: 0,
      amount: Number(el.dataset.parallax || 80),
    }))
    .filter((item) => item.img);

  const lerp = (start, end, amt) => {
    return start + (end - start) * amt;
  };

  const update = () => {
    current.forEach((item) => {
      const rect = item.el.getBoundingClientRect();

      const progress =
        (window.innerHeight - rect.top) / (window.innerHeight + rect.height);

      item.progress = lerp(item.progress, (progress - 0.5) * 2, 0.08);

      item.img.style.transform = `translate3d(0, ${item.progress * item.amount}px, 0) scale(1.15)`;
    });

    requestAnimationFrame(update);
  };

  update();
};

const init = () => {
  console.log("Find Your Shell Jacket");
  const wrap = document.getElementById("fysj");
  const isTopPage = wrap.dataset.page === "top";

  requestAnimationFrame(raf);

  if (isTopPage) {
    // TODO
    setParallax(wrap);
  } else {
    setParallax(wrap);
    setSwiper(wrap);
    setModal(wrap);
    new ScrollHint(".js-scrollable");

    const compareChart = wrap.querySelectorAll(".compare__chart");
    compareChart.forEach((chartWrap) => {
      const targetId = chartWrap.dataset.key;
      setRaderChart(chartWrap, targetId, false);
    });
  }
};

document.addEventListener("DOMContentLoaded", () => init(document));
document.addEventListener("shopify:section:load", (event) =>
  init(event.target),
);
